import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    IconName,
    IconPrefix,
    IconLookup,
    IconDefinition,
    faSkullCrossbones,
    faExclamationTriangle,
    faInfoCircle,
    faCheck
} from '@fortawesome/free-solid-svg-icons';

export enum AlertId {
    Danger,
    Info,
    Warning,
    Success
}

export type AlertType = {
    id: AlertId;
    typeClass: string;
    iconClass: IconDefinition;
};

export const AlertTypes: Record<AlertId, AlertType> = {
    [AlertId.Danger]: {
        id: AlertId.Danger,
        typeClass: 'alert-danger',
        iconClass: faSkullCrossbones
    },
    [AlertId.Warning]: {
        id: AlertId.Warning,
        typeClass: 'alert-warning',
        iconClass: faExclamationTriangle
    },
    [AlertId.Info]: {
        id: AlertId.Info,
        typeClass: 'alert-info',
        iconClass: faInfoCircle
    },
    [AlertId.Success]: {
        id: AlertId.Success,
        typeClass: 'alert-success',
        iconClass: faCheck
    }
};

export type BaseAlertProps = {
    alertType?: AlertType;
    includeCloseButton?: boolean;
    animated?: boolean;
    includeImage?: boolean;
    strong?: boolean;
    customImage?: IconName | [IconPrefix, IconName] | IconLookup;
    message: string;
    className?: string;
};

const BaseAlert = ({
    alertType,
    includeCloseButton,
    animated,
    includeImage,
    strong,
    customImage,
    message,
    className
}: BaseAlertProps) => {
    let rootClasses = `alert `;
    rootClasses += className ? `${className} ` : '';
    rootClasses +=
        alertType === undefined ? 'alert-primary' : alertType.typeClass;

    let closeButton = null;
    if (includeCloseButton) {
        rootClasses += ' alert-dismissible';
        closeButton = (
            <button
                id='close'
                data-testid='close-icon'
                className='btn-close'
                data-bs-dismiss='alert'></button>
        );
    }

    if (animated) {
        rootClasses += ' fade show';
    }

    let imageItem = null;
    let messageLineClasses = '';
    if (includeImage) {
        if (customImage == null && alertType !== undefined) {
            imageItem = <FontAwesomeIcon icon={alertType.iconClass} />;
        } else {
            if (customImage) imageItem = <FontAwesomeIcon icon={customImage} />;
        }
        messageLineClasses = 'pl-2';
    }

    if (strong) {
        messageLineClasses += ' font-weight-bold';
    }

    const iconTestId = imageItem == null ? '' : 'alert-icon';
    return (
        <div className={rootClasses} role='alert'>
            <span style={{ paddingRight: '0.5rem' }} data-testid={iconTestId}>
                {imageItem}
            </span>
            <span className={messageLineClasses}>{message}</span>
            {closeButton}
        </div>
    );
};

export default BaseAlert;
